import React from 'react';
import { Wrench, Clock, Mail } from 'lucide-react';

const MaintenancePage = ({ message }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F5EFE7] to-[#E8DCC8] flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-12 text-center">
          {/* Icon */}
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <div className="w-24 h-24 bg-gradient-to-br from-[#8B7355] to-[#6B5744] rounded-full flex items-center justify-center animate-pulse">
                <Wrench className="w-12 h-12 text-white" />
              </div>
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#D5C4A1] rounded-full flex items-center justify-center">
                <Clock className="w-5 h-5 text-[#5C4033]" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl font-bold text-[#5C4033] mb-4">
            Bakım Modundayız
          </h1>

          {/* Arabic Title */}
          <p className="text-2xl text-[#8B7355] mb-8" style={{ fontFamily: '"Traditional Arabic", "Scheherazade New", serif' }}>
            وضع الصيانة
          </p>

          {/* Message */}
          <div className="bg-[#F5EFE7] rounded-xl p-6 mb-8">
            <p className="text-lg text-[#5C4033] leading-relaxed">
              {message || "Sitemiz şu anda bakımdadır. Lütfen daha sonra tekrar deneyin."}
            </p>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <div className="bg-[#FFF4E6] rounded-lg p-4">
              <div className="flex items-center justify-center gap-2 text-[#8B7355]">
                <Clock className="w-5 h-5" />
                <span className="font-medium">Kısa Süre İçinde</span>
              </div>
            </div>
            <div className="bg-[#FFF4E6] rounded-lg p-4">
              <div className="flex items-center justify-center gap-2 text-[#8B7355]">
                <Wrench className="w-5 h-5" />
                <span className="font-medium">İyileştirme Yapıyoruz</span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t border-[#E8DCC8] pt-6">
            <p className="text-sm text-[#8B7355]">
              Anlayışınız için teşekkür ederiz 🙏
            </p>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="mt-6 text-center">
          <p className="text-[#8B7355] text-sm">
            © {new Date().getFullYear()} Kuran-ı Kerim
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
